var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForumDetailsTimeicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.039,
    height: 13.039,
    viewBox: "0 0 13.039 13.039",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-clock",
    "data-name": "Icon awesome-clock",
    d: "M7.082.563a6.52,6.52,0,1,0,6.52,6.52A6.518,6.518,0,0,0,7.082.563Zm1.5,9.2L6.264,8.081a.318.318,0,0,1-.129-.255V3.4a.316.316,0,0,1,.315-.315H7.713a.316.316,0,0,1,.315.315v3.62L9.7,8.236a.315.315,0,0,1,.068.442L9.025,9.7A.318.318,0,0,1,8.583,9.766Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#a7a7a7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForumDetailsTimeicon);
export default __webpack_public_path__ + "static/media/forum-details-timeicon.21d4c258d6bb4a6a32a7fac1f013bcd5.svg";
export { ForwardRef as ReactComponent };